import { UfoIcon } from '@/assets/icons'
import React from 'react'
import { Centered, StateMessage, StateTitle } from './PublicPageState.styles'

interface PublicUnavailableStateProps {
	/** e.g. "Trip Unavailable". */
	title: string
	/** Per-page wording, e.g. "This trip doesn't exist or has been set to private…". */
	message: string
}

/**
 * The UFO "unavailable / private" state shared by every public share page: an
 * unknown code, a deleted trip, and a master-switch-off trip all land here (the
 * endpoints answer 404 for each, deliberately indistinguishable).
 */
const PublicUnavailableState: React.FC<PublicUnavailableStateProps> = ({ title, message }) => (
	<Centered>
		<UfoIcon width={250} height={250} />
		<StateTitle>{title}</StateTitle>
		<StateMessage>{message}</StateMessage>
	</Centered>
)

export default PublicUnavailableState
